import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import SurveyLayout from '../components/surveyLayout'

function Survey() {
  const location = useLocation()
  const isCompletePage = location.pathname === '/survey/complete'

  return (
    <SurveyLayout>
      {!isCompletePage && <SurveyLayout.Header />}
      <SurveyLayout.Section fullHeight={isCompletePage}>
        <Outlet />
      </SurveyLayout.Section>
    </SurveyLayout>
  )
}

export default Survey
